import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldGroup } from '../../../libs/formLib';
import ButtonIcon from '../../common/ButtonIcon';
import { useNavigate } from 'react-router-dom';
import { animateScroll } from 'react-scroll';

import { sumBy, toNumber } from 'lodash';

import PropTypes from 'prop-types';
import {
  Row,
  Card,
  CardBody,
  FormGroup,
  Label,
  FormFeedback,
  Col,
  Button,
  TabContent,
  TabPane,
  Alert
} from 'reactstrap';
import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import HistoryTab from '../section/HistoryTab';

import BZAPIService from '../../../services/BZAPIService';
import ProductPriority from '../section/ProductPriority';
import DefaultConfigTab from '../section/DefaultConfigTab';
import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';

// constants
import SETTINGS from '../../../constants/settings';
// import { active } from 'browser-sync';

const ConfigFormServiceNow = ({
  settings,
  vendor,
  isReadOnly,
  vendorLabel,
  vendorId,
  bugsDateBack,
  setBugsDateBack,
  vendorPriorityOptions,
  vendorStatusOptions,
  // vendorResolutionOptions,
  snIntegrationCheck,
  services,
  vendors,
  priorityStats,
  setPriorityStats,
  // bugOptions,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  setVendorStatuses,
  vendorStatuses,
  fields,
  handleFieldChange,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  keywords,
  setKeywords,
  searchFields,
  setSearchFields,
  snCompanySysId,
  setSnCompanySysId,
  setServices,
  setVendors,
  buildVendorStat,
  setBugs,
  isConfigured,
  syncOnly,
  setSyncOnly,
  // supportCasesCount,
  // setCases,
  // isCasesOn,
  // setIsCasesOn,
  isCve,
  setIsCve,
  bugRisk,
  loading,
  excludedComponents,
  setExcludedComponents,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [isUpdatingCreds, setIsUpdatingCreds] = useState(false);

  const [includedComponents, setIncludedComponents] = useState([]);
  const [loader, setLoader] = useState(false);

  const [riskError, setRiskError] = useState('');

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);

  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState('0');
  const [limit, setLimit] = useState('2500');

  const [isForceRun, setIsForceRun] = useState(false);
  const [nextRun, setNextRun] = useState();
  const [timeUnit, setTimeUnit] = useState('');
  const [timeValue, setTimeValue] = useState({});

  async function setBugServiceFrequency() {
    // Check for time unit, post frequency
    const data = {
      timeUnit,
      number: toNumber(timeValue.value)
    };
    if (vendorId.length) {
      try {
        const res = await BZAPIService.postBugServiceSchedule(vendorId, data, { method: 'POST' });
        setNextRun(res?.data?.nextRunUTC);
        console.log('res', res);
      } catch (e) {
        console.log(e);
      }
    }
  }

  async function onLoad() {
    setLoader(true);
    try {
      let components = (await BZAPIService.getComponents(vendorId, query, offset, limit)) || [];

      settings?.excludedBugComponents
        ? setExcludedComponents(settings.excludedBugComponents)
        : setExcludedComponents([]);

      // setIncludedComponents(defaults.vendorData.vendorBugComponents);
      settings.searchFields
        ? setSearchFields(settings.searchFields)
        : setSearchFields(vendor?.vendorData?.searchFields);

      setIncludedComponents(components ? components.results : []);

      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  }

  useEffect(() => {
    onLoad();
    console.log('bug risk', bugRisk);
  }, []);

  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority) &&
      vendorStatuses.length &&
      (fields.snSecretId || (fields.username && fields.password && fields.mfaSecret))
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
  }, [
    fields,
    bugsDateBack,
    priorityStats,
    vendorStatuses,
    priorityMaps,
    keywords,
    excludedComponents,
    isCve,
    searchFields,
    snCompanySysId,
    bugRisk
  ]);

  async function testCreds() {
    setIsTestingValidCredentials(true);
    const data = {
      username: fields.username,
      password: fields.password,
      mfaSecret: fields.mfaSecret
    };
    // console.log('data', data);
    const result = await BZAPIService.vendorTestCreds(vendorId, data);
    setIsTestingValidCredentials(false);
    if (result && result.completed) {
      // valid creds
      // console.log('result.active_iq_customers', result.active_iq_customers);
      fields.refreshToken = result.refresh_token;
      setIsValidCredentials(true);
      setIsAddingCredentials(false);
      setIsUpdatingCreds(true);
      toast.success(`Credentials validated.`);
    } else {
      toast.error(`Unable to validate credentials.`);
      setIsAddingCredentials(false);
    }

    console.log('result', result);
  }

  // async function saveServiceAWSSecret() {
  //   const data = {
  //     secret: {
  //       ClientId: fields.username,
  //       ClientSecret: fields.password
  //     },
  //     vendorId: 'servicenow',
  //     key: 'serviceApi'
  //   };
  //   // service api secret
  //   return BZAPIService.createOrUpdateAWSSecret(data);
  // }

  async function saveServiceNowSecret() {
    const data = {
      secret: {
        username: fields.username,
        password: fields.password,
        mfaSecret: fields.mfaSecret
      },
      vendorId: 'sn',
      key: 'snApi'
    };

    // support api secret
    return BZAPIService.createOrUpdateAWSSecret(data);
  }

  async function saveConfig(snSecret) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      bugsDateBack: bugsDateBack,
      // serviceSecretId: serviceSecret.Name,
      snSecretId: snSecret.Name,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      vendorPriorities,
      vendorStatuses,
      type: SETTINGS.VENDOR,
      excludedBugComponents: excludedComponents,
      excludedKws: keywords,
      searchFields: searchFields,
      filterCVEs: isCve
      // supportCasesCount: isCasesOn ? supportCasesCount : 0,
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun, isUpdatingCreds);
  }

  async function handleSave() {
    setRiskError('');
    try {
      setIsSubmitted(true);
      setIsLoading(true);
      // Check if Credentials test is complete
      if (!isValidCredentials && !fields.username) {
        console.log('Validated Credentials', isValidCredentials);
        toast.error('Credentials Test Missing.');
        setValidated(false);
        setActiveTab('2');
        setIsLoading(false);
        return;
      }
      // Validate
      if (!bugsDateBack.length || !snCompanySysId) {
        console.log('failed validation');
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }
      // Validate status
      if (!vendorStatuses.length || !priorityMaps.length) {
        setValidated(false);
        setActiveTab('4');
        setIsLoading(false);
        return;
      }
      // Validate Secrets

      if (!fields.snSecretId) {
        if (
          // !fields.serviceClientId ||
          // !fields.serviceClientSecret ||
          !fields.username ||
          !fields.password ||
          !fields.mfaSecret
        ) {
          console.log('misisng secret');
          setValidated(false);
          setIsLoading(false);
          setActiveTab('2');
          return;
        }
      }

      // Validate Risk Score
      const activeRisk = bugRisk.filter(y => {
        return y.active;
      });
      const activeSum = sumBy(activeRisk, risk => {
        return risk.value;
      });

      if (activeSum < 100 && activeSum > 1) {
        console.log('Bug risk share is less than 100');
        setValidated(false);
        setIsLoading(false);
        setActiveTab('5');
        setRiskError('Bug risk share total must be 100');
        return;
      }

      let snSecret;

      if (
        // fields.serviceClientSecret &&
        // fields.serviceClientId &&
        fields.username &&
        fields.password &&
        fields.mfaSecret
      ) {
        // Updated secrets
        // serviceSecret = await saveServiceAWSSecret();
        snSecret = await saveServiceNowSecret();
      } else {
        // use existing secrets
        // serviceSecret = { Name: fields.serviceSecretId };
        snSecret = { Name: fields.snSecretId };
      }

      // validate priority maps
      let validPriorities = true;
      priorityMaps.map(item => {
        if (!item.vendorPriority || !item.snPriority) validPriorities = false;
        return item;
      });
      if (!validPriorities) {
        console.log('Invalid priorities');
        setValidated(false);
        setIsLoading(false);
        return false;
      }

      await saveConfig(snSecret);
      // set updated secretId
      // fields.serviceSecretId = serviceSecret.Name;
      fields.snSecretId = snSecret.Name;
      setBugServiceFrequency();
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setIsUpdatingCreds(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollTo(70);
  }

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        hasBugRisk={false}
      />

      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />

        <form noValidate style={{ minWidth: '100%' }}>
          <TabPane tabId="2">
            {activeTab === '2' && (
              // <input type="hidden" value="prayer" />
              <Card bg={'light'} text={'dak'} className="mb-4">
                {/* <FalconCardHeader title="Vendor settings" /> */}
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          ServiceNow API Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div className="d-flex align-items-center">
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                data-testid={'servicenow-set-credentials-btn'}
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>

                              {fields.snSecretId || isValidCredentials ? (
                                <div className="d-flex align-items-center" data-testid={'sn-creds-stored-message'}>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  ServiceNow API Credentials Stored
                                </div>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="username"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.username}
                                  label={'ServiceNow username'}
                                  data-testid={'servicenow-username'}
                                  showFeedback={!fields.username && isSubmitted}
                                  feedback={'Please specify a ServiceNow username.'}
                                  placeholder="Enter ServiceNow username"
                                  // style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col>
                                <FieldGroup
                                  type="password"
                                  id="password"
                                  label={'ServiceNow password'}
                                  data-testid={'servicenow-password'}
                                  autoComplete="new-password"
                                  placeholder="Enter ServiceNow password"
                                  onChange={handleFieldChange}
                                  value={fields.password}
                                  showFeedback={!fields.password && isSubmitted}
                                  feedback={'Please specify a ServiceNow password.'}
                                  required
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="password"
                                  id="mfaSecret"
                                  label={'ServiceNow MFA secret'}
                                  data-testid={'servicenow-cloud-password'}
                                  autoComplete="new-mfaSecret"
                                  placeholder="Enter ServiceNow MFA secret"
                                  onChange={handleFieldChange}
                                  value={fields.mfaSecret}
                                  showFeedback={!fields.mfaSecret && isSubmitted}
                                  feedback={'Please specify a ServiceNow MFA secret.'}
                                  required
                                />
                              </Col>
                            </Row>
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconClassName="fs--2"
                              style={{ marginRight: '10px' }}
                              data-testid={'servicenow-cancel-creds-btn'}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <FormFeedback
                          className={
                            // !fields.serviceSecretId &&
                            // !fields.snSecretId &&
                            // !fields.serviceClientId &&
                            // !fields.serviceClientSecret &&
                            !fields.username && !fields.password && !fields.mfaSecret && isSubmitted ? 'd-block' : ''
                          }
                          type="invalid"
                        >
                          <Alert color="danger">Please specify credentials.</Alert>
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>
          <DefaultConfigTab
            activeTab={activeTab}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
          />
          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorId={vendorId}
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                setVendorStatuses={setVendorStatuses}
                vendorStatuses={vendorStatuses}
                isSubmitted={isSubmitted}
                priorityMaps={priorityMaps}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                includedComponents={includedComponents}
                setIncludedComponents={setIncludedComponents}
                excludedComponents={excludedComponents}
                setExcludedComponents={setExcludedComponents}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
                vendorLabel={vendorLabel}
                setLoader={setLoader}
                setQuery={setQuery}
                query={query}
                offset={offset}
                limit={limit}
                setOffset={setOffset}
                setLimit={setLimit}
                loader={loader}
                isCve={isCve}
                setIsCve={setIsCve}
                // supportCasesCount={supportCasesCount}
                // setCases={setCases}
                // isCasesOn={isCasesOn}
                // setIsCasesOn={setIsCasesOn}
              />
            )}
          </TabPane>

          <TabPane tabId="6">{activeTab === '6' && <HistoryTab vendorId={vendorId} />}</TabPane>

          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
                allRequired={allRequired}
                isUpdated={isUpdated}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormServiceNow.propTypes = {
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdErrors: PropTypes.bool,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  vendorStatuses: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  // supportCasesCount: PropTypes.number,
  // setCases: PropTypes.func,
  // isCasesOn: PropTypes.bool,
  // setIsCasesOn: PropTypes.func,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  bugRisk: PropTypes.array,
  setBugRisk: PropTypes.func,
  loading: PropTypes.bool,
  excludedComponents: PropTypes.array,
  setExcludedComponents: PropTypes.func,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func
};
export default ConfigFormServiceNow;
